import React from "react";

const FaultConfiguration = () => {
  return (
    <div>
      <h1>Fault Configuration</h1>
    </div>
  );
};

export default FaultConfiguration;
